/**
 * Input Schema of AlertaCarga
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {AlertaCarga} from '@/model/resource/AlertaCarga'
import {AlertaCollection} from '@/model/collection/AlertaCollection'
import {CargaCollection} from '@/model/collection/CargaCollection'
import {MotoristaCollection} from '@/model/collection/MotoristaCollection'

/* TODO: review generated schema */
export class InputAlertaCargaSchema extends Schema {
  collectionAlerta = new AlertaCollection().noPagination()
  collectionCarga = new CargaCollection().noPagination()
  collectionMotorista = new MotoristaCollection().noPagination()

  readonly name = 'InputAlertaCarga'

  readonly fieldSet: FieldSet<AlertaCarga> = {
    alerta: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionAlerta.all(),
      },
    }),
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    motorista: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionMotorista.all(),
      },
    }),
    dataAlerta: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
